'use client'

import React from 'react'
import { Calendar, MapPin, Users, Clock } from 'lucide-react'

interface CampsTableProps {
  camps: any[]
}

const CampsTable: React.FC<CampsTableProps> = ({ camps }) => {
  if (camps.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg p-8 text-center">
        <p className="text-gray-500">Keine Camps gefunden, die den Filterkriterien entsprechen.</p>
      </div>
    )
  }

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold">Camps Übersicht</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-3 px-6 font-medium text-gray-900">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4" />
                  Camp Name
                </div>
              </th>
              <th className="text-left py-3 px-6 font-medium text-gray-900">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4" />
                  Startdatum
                </div>
              </th>
              <th className="text-left py-3 px-6 font-medium text-gray-900">
                <div className="flex items-center gap-2">
                  <Clock className="h-4 w-4" />
                  Enddatum
                </div>
              </th>
              <th className="text-left py-3 px-6 font-medium text-gray-900">
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4" />
                  Ort
                </div>
              </th>
              <th className="text-center py-3 px-6 font-medium text-gray-900">
                <div className="flex items-center justify-center gap-2">
                  <Users className="h-4 w-4" />
                  Anmeldungen
                </div>
              </th>
              <th className="text-center py-3 px-6 font-medium text-gray-900">
                <div className="flex items-center justify-center gap-2">
                  <Users className="h-4 w-4" />
                  Bestätigt
                </div>
              </th>
              <th className="text-center py-3 px-6 font-medium text-gray-900">Warteliste</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {camps.map((camp) => (
              <tr key={camp.id} className="hover:bg-gray-50">
                <td className="py-4 px-6">
                  <div className="flex items-center gap-3">
                    <div>
                      <div className="font-medium text-gray-900">{camp.title}</div>
                      {camp.category && (
                        <div className="text-xs text-gray-500">
                          {typeof camp.category === 'object' ? camp.category.name : camp.category}
                        </div>
                      )}
                      {camp.isPaidCamp && (
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mt-1">
                          SAACnd Step
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td className="py-4 px-6 text-sm text-gray-600">
                  {camp.date ? formatDate(camp.date) : '-'}
                </td>
                <td className="py-4 px-6 text-sm text-gray-600">
                  {camp.endDate
                    ? formatDate(camp.endDate)
                    : camp.date
                      ? formatDate(camp.date)
                      : '-'}
                </td>
                <td className="py-4 px-6 text-sm text-gray-600">{camp.location || '-'}</td>
                <td className="py-4 px-6 text-center">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    {camp.totalRegistrations || 0}
                  </span>
                </td>
                <td className="py-4 px-6 text-center">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                    {camp.confirmedRegistrations || 0}
                  </span>
                </td>
                <td className="py-4 px-6 text-center">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-amber-100 text-amber-800">
                    {camp.wartelisteRegistrations || 0}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CampsTable
